import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import React from "react";
import { DeploymentCommit } from "users/super-users/deployment-commit";

const VersionLine = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
  fontSize: "1.2em",
  marginTop: theme.spacing(2),
  textAlign: "center",
}));

interface DeploymentVersionProps {
  /** The API's commit; absent until `super-user/version` answers. */
  api?: DeploymentCommit;
  frontend: DeploymentCommit;
}

/**
 * The commits the deployed frontend and API were built from. One commit when both sides agree,
 * which is the usual case; both, labeled, when one side has deployed without the other.
 */
export default function DeploymentVersion({ api, frontend }: Readonly<DeploymentVersionProps>) {
  if (!api || api.isEqualTo(frontend)) {
    return (
      <VersionLine>
        Version: <CommitReference commit={frontend} />
      </VersionLine>
    );
  }

  return (
    <VersionLine>
      Version: frontend <CommitReference commit={frontend} />, API <CommitReference commit={api} />
    </VersionLine>
  );
}

function CommitReference({ commit }: Readonly<{ commit: DeploymentCommit }>) {
  if (!commit.url) {
    return <span title={commit.sha}>{commit.short}</span>;
  }

  return (
    <Link href={commit.url} target="_blank" rel="noopener noreferrer" title={commit.sha} color="inherit">
      {commit.short}
    </Link>
  );
}
